// Access type means if user has access to the app (NONE means no access, GROWTHMENTOR means access to growthmentor app)
export const ACCESS_TYPE = Object.freeze({
  NONE: 'NONE',
  GROWTHMENTOR: 'GROWTHMENTOR',
})

// Current "user mode" (only mentor can switch between mentee/mentor, and mentee is always mentee)
export const ACTOR_TYPE = Object.freeze({
  NONE: 'NONE',
  MENTEE: 'MENTEE',
  MENTOR: 'MENTOR',
})

// Mentor profile status
export const MENTOR_STATUS = Object.freeze({
  ACTIVE: 'ACTIVE',
  HIDDEN_FROM_AUTO_DECLINE: 'HIDDEN_FROM_AUTO_DECLINE',
  HIDDEN: 'HIDDEN',
  PROFILE_INCOMPLETE: 'PROFILE_INCOMPLETE',
  NOT_MENTOR: 'NOT_MENTOR',
})

// Each user must complete their profile before using some features
export const PROFILE_STATUS = Object.freeze({
  NOT_COMPLETE: 'NOT_COMPLETE',
  COMPLETE: 'COMPLETE',
})

export const PROFILE_VISIBILITY = Object.freeze({
  VISIBLE: 'VISIBLE',
  INVISIBLE: 'INVISIBLE',
})

// Base user role (mentee is always MENTEE, mentor is always MENTOR not matter what mode they are in, GUEST is not logged-in user)
export const ROLE = Object.freeze({
  GUEST: 'GUEST',
  MENTEE: 'MENTEE',
  MENTOR: 'MENTOR',
})

export const TEAM_ROLE = Object.freeze({
  NONE: 'NONE',
  INVITED: 'INVITED',
  MEMBER: 'MEMBER',
  OWNER: 'OWNER',
})

export const SUBSCRIPTION_BILLING_CYCLE = Object.freeze({
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  YEAR: 'YEAR',
})

export const SUBSCRIPTION_NEXT_BILLING_PERIOD_STATUS = Object.freeze({
  // NONE means that subscription is not active and will not be
  NONE: 'NONE',
  // EXPIRED means that subscription is not active and will not be, but it was active in the past
  EXPIRED: 'EXPIRED',
  // ACTIVE means that subscription is active and will be active
  ACTIVE: 'ACTIVE',
  // CANCELED means that subscription is active, but it will not be active
  CANCELED: 'CANCELED',
  // SCHEDULED means that subscription is active, but new subscription will be active (maybe someone upgrades plan)
  SCHEDULED: 'SCHEDULED',
})

export const SUBSCRIPTION_STATUS = Object.freeze({
  // User physically does NOT pay for subscription with real money
  NOT_PAID: 'NOT_PAID',
  // User physically pays for subscription with real money
  PAID: 'PAID',
})

// This status should only be checked for mentors (they are the only ones that can connect to stripe)
export const SUBSCRIPTION_STRIPE_CONNECTION_STATUS = Object.freeze({
  // User is not connected to stripe
  NOT_ACTIVE: 'NOT_ACTIVE',
  // User is connected to stripe
  ACTIVE: 'ACTIVE',
})

export const SUBSCRIPTION_TIER = Object.freeze({
  // User does not have any subscription
  NONE: 'NONE',
  // User has a "trial" subscription (available through checkbox in admin panel)
  TRIAL: 'TRIAL',
  // User has a "baby" subscription (it is subscription with lower price that cannot be bought by user directly, only if user cancels subscription)
  BABY: 'BABY',
  // User has a "basic" subscription (it is each subscription that can be bought by user directly in plans page or in checkout page)
  USER: 'USER',
  // User has a "team" subscription
  TEAM: 'TEAM',
  // User has a "permanent" subscription (available through checkbox in admin panel)
  PERMANENT: 'PERMANENT',
})

export const SUBSCRIPTION_TYPE = Object.freeze({
  NONE: 'NONE',
  // User has legacy subscription that cannot be bought in any way
  LEGACY: 'LEGACY',
  LIVE: 'LIVE',
})

export const SUBSCRIPTION_GROUP = Object.freeze({
  BASIC: 'BASIC',
  LIGHT: 'LIGHT',
  PRO: 'PRO',
  HIBERNATION: 'HIBERNATION',
})

export const SUBSCRIPTION_TRIAL_INTERVAL = Object.freeze({
  NONE: 'NONE',
  ONCE: 'ONCE',
  MONTHLY: 'MONTHLY',
})

export const OBJECT_PERMISSIONS = Object.freeze({
  COLLECTIONS: {
    NOT_FOLLOWING: 'NOT_FOLLOWING',
    FOLLOWING: 'FOLLOWING',
    APPLIED: 'APPLIED',
    NOT_APPLIED: 'NOT_APPLIED',
    REQUESTED: 'REQUESTED',
    DECLINED: 'DECLINED',
  },
  CONNECTION_STATUS: {
    ACCEPTED: 'ACCEPTED',
    NOT_CONNECTED: 'NOT_CONNECTED',
  },
  GROUPS: {
    NOT_APPLIED: 'NOT_APPLIED',
    APPROVED: 'APPROVED',
    REQUESTED: 'REQUESTED',
  },
  OPPORTUNITIES: {
    NOT_APPLIED: 'NOT_APPLIED',
    OWNER: 'OWNER',
    VIEWER: 'VIEWER',
    LIKE: 'LIKE',
  },
  MENTORS: {
    OWNER: 'OWNER',
    VIEWER: 'VIEWER',
    PROVIDES_COACHING: 'PROVIDES_COACHING',
  },
  MENTEES: {
    OWNER: 'OWNER',
    VIEWER: 'VIEWER',
  },
  SESSIONS: {
    MENTEE: 'MENTEE',
    MENTOR: 'MENTOR',
  },
  REVIEWS: {
    FAVORITED: 'FAVORITED',
  },
})
